/* svelte-comps/Carousel.svelte generated by Svelte v3.59.1 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	destroy_each,
	detach,
	element,
	globals,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_style,
	space,
	src_url_equal,
	text
} from "svelte/internal";

const { window: window_1 } = globals;
import arrow from '../../img/lg-circle.svg';
import { onMount } from 'svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[21] = list[i];
	child_ctx[23] = i;
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[21] = list[i];
	return child_ctx;
}

// (102:6) {#each content as c}
function create_each_block_1(ctx) {
	let div;
	let img;
	let img_src_value;
	let t;
	let mounted;
	let dispose;

	function click_handler() {
		return /*click_handler*/ ctx[12](/*c*/ ctx[21]);
	}

	function mouseenter_handler() {
		return /*mouseenter_handler*/ ctx[13](/*c*/ ctx[21]);
	}

	return {
		c() {
			div = element("div");
			img = element("img");
			t = space();

			set_style(img, "border", /*activeCard*/ ctx[3] === /*c*/ ctx[21].type
			? '2px solid'
			: '2px solid transparent');

			attr(img, "alt", "postcard image");
			if (!src_url_equal(img.src, img_src_value = /*c*/ ctx[21].img)) attr(img, "src", img_src_value);
			attr(div, "class", "slide");
			set_style(div, "width", "calc(" + 100 / /*content*/ ctx[0].length + "%" + (/*cardNumber*/ ctx[2] > 1 ? ' - 40px' : '') + ")");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, img);
			append(div, t);

			if (!mounted) {
				dispose = [
					listen(img, "click", click_handler),
					listen(img, "mouseenter", mouseenter_handler)
				];

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*activeCard, content*/ 9) {
				set_style(img, "border", /*activeCard*/ ctx[3] === /*c*/ ctx[21].type
				? '2px solid'
				: '2px solid transparent');
			}

			if (dirty & /*content*/ 1 && !src_url_equal(img.src, img_src_value = /*c*/ ctx[21].img)) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*content, cardNumber*/ 5) {
				set_style(div, "width", "calc(" + 100 / /*content*/ ctx[0].length + "%" + (/*cardNumber*/ ctx[2] > 1 ? ' - 40px' : '') + ")");
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (137:4) {#each content as c, i}
function create_each_block(ctx) {
	let button;
	let button_class_value;
	let mounted;
	let dispose;

	function click_handler_4() {
		return /*click_handler_4*/ ctx[15](/*i*/ ctx[23]);
	}

	return {
		c() {
			button = element("button");

			attr(button, "class", button_class_value = /*current_index*/ ctx[4] === /*i*/ ctx[23]
			? 'active'
			: '');
		},
		m(target, anchor) {
			insert(target, button, anchor);

			if (!mounted) {
				dispose = listen(button, "click", click_handler_4);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*current_index*/ 16 && button_class_value !== (button_class_value = /*current_index*/ ctx[4] === /*i*/ ctx[23]
			? 'active'
			: '')) {
				attr(button, "class", button_class_value);
			}
		},
		d(detaching) {
			if (detaching) detach(button);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let div3;
	let div1;
	let div0;
	let t0;
	let img0;
	let img0_src_value;
	let t1;
	let button0;
	let img1;
	let img1_src_value;
	let t2;
	let button1;
	let img2;
	let img2_src_value;
	let t3;
	let div2;
	let t4;
	let button2;
	let t5;
	let button2_disabled_value;
	let mounted;
	let dispose;
	add_render_callback(/*onwindowresize*/ ctx[11]);
	let each_value_1 = /*content*/ ctx[0];
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let each_value = /*content*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div3 = element("div");
			div1 = element("div");
			div0 = element("div");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t0 = space();
			img0 = element("img");
			t1 = space();
			button0 = element("button");
			img1 = element("img");
			t2 = space();
			button1 = element("button");
			img2 = element("img");
			t3 = space();
			div2 = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t4 = space();
			button2 = element("button");
			t5 = text("Select this Postcard");
			attr(div0, "class", "slider");
			set_style(div0, "width", /*sliderWidth*/ ctx[5] + "%");
			attr(img0, "class", "slider-sizer");
			set_style(img0, "width", "calc(" + 100 / /*cardNumber*/ ctx[2] + "%" + (/*cardNumber*/ ctx[2] > 1 ? ' - 40px' : '') + ")");
			attr(img0, "alt", "");
			if (!src_url_equal(img0.src, img0_src_value = /*content*/ ctx[0][/*content*/ ctx[0].length - 1].img)) attr(img0, "src", img0_src_value);
			attr(div1, "class", "carousel");
			if (!src_url_equal(img1.src, img1_src_value = arrow)) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "arrow");
			attr(button0, "class", "prev");
			if (!src_url_equal(img2.src, img2_src_value = arrow)) attr(img2, "src", img2_src_value);
			attr(img2, "alt", "arrow");
			attr(button1, "class", "next");
			attr(div2, "class", "carousel-dots");
			attr(div3, "class", "carousel-wrapper");
			attr(button2, "class", "carousel-select");
			button2.disabled = button2_disabled_value = /*content*/ ctx[0][/*current_index*/ ctx[4]] === /*activeCard*/ ctx[3];
		},
		m(target, anchor) {
			insert(target, div3, anchor);
			append(div3, div1);
			append(div1, div0);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				if (each_blocks_1[i]) {
					each_blocks_1[i].m(div0, null);
				}
			}

			append(div1, t0);
			append(div1, img0);
			append(div3, t1);
			append(div3, button0);
			append(button0, img1);
			append(div3, t2);
			append(div3, button1);
			append(button1, img2);
			append(div3, t3);
			append(div3, div2);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(div2, null);
				}
			}

			insert(target, t4, anchor);
			insert(target, button2, anchor);
			append(button2, t5);

			if (!mounted) {
				dispose = [
					listen(window_1, "resize", /*onwindowresize*/ ctx[11]),
					listen(div0, "mouseleave", /*mouseleave_handler*/ ctx[14]),
					listen(img0, "click", click_handler_1),
					listen(button0, "click", click_handler_2),
					listen(button1, "click", click_handler_3),
					listen(button2, "click", /*click_handler_5*/ ctx[16])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*content, cardNumber, activeCard, screenWidth, handleClick, handleHover*/ 207) {
				each_value_1 = /*content*/ ctx[0];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(div0, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_1.length;
			}

			if (dirty & /*sliderWidth*/ 32) {
				set_style(div0, "width", /*sliderWidth*/ ctx[5] + "%");
			}

			if (dirty & /*cardNumber*/ 4) {
				set_style(img0, "width", "calc(" + 100 / /*cardNumber*/ ctx[2] + "%" + (/*cardNumber*/ ctx[2] > 1 ? ' - 40px' : '') + ")");
			}

			if (dirty & /*content*/ 1 && !src_url_equal(img0.src, img0_src_value = /*content*/ ctx[0][/*content*/ ctx[0].length - 1].img)) {
				attr(img0, "src", img0_src_value);
			}

			if (dirty & /*current_index, go_to_index, content*/ 273) {
				each_value = /*content*/ ctx[0];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div2, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*content, current_index, activeCard*/ 25 && button2_disabled_value !== (button2_disabled_value = /*content*/ ctx[0][/*current_index*/ ctx[4]] === /*activeCard*/ ctx[3])) {
				button2.disabled = button2_disabled_value;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div3);
			destroy_each(each_blocks_1, detaching);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t4);
			if (detaching) detach(button2);
			mounted = false;
			run_all(dispose);
		}
	};
}

const click_handler_1 = () => {
	
};

const click_handler_2 = () => {
	
};

const click_handler_3 = () => {
	
};

function instance($$self, $$props, $$invalidate) {
	let sliderWidth;
	let slideWidth;
	let { content } = $$props;
	let { selectCard } = $$props;
	let { hoverSelectCard } = $$props;
	let screenWidth;
	let activeCard = '';
	let cardNumber;

	function handleClick(newCard, advance = false) {
		$$invalidate(3, activeCard = newCard);
		selectCard(newCard, advance);
	}

	// handleHover. fxn for mouse enter and leave events
	// hoverSelectCard changes temp card value in PostcardContainer.js
	// params -> 1. viewBack Boolean for preview section
	// 2. temp card value
	function handleHover(action, item) {
		if (action === 'leave') {
			// keep view boolean false for now. 
			// we don't want to change because we don't know what previous value was.
			hoverSelectCard(false, '');
		} else {
			hoverSelectCard(false, item);
		}
	}

	let total_slides = 0;
	let current_index = 0;
	let slider;
	let carousel;

	onMount(() => {
		total_slides = jQuery(".slide").length;
		slider = jQuery(".slider");
		carousel = jQuery(".carousel");

		jQuery(".prev").click(function () {
			go_to_index(current_index - 1);
			return false;
		});

		jQuery(window).on('swiperight', function () {
			go_to_index(current_index - 1);
		});

		jQuery(".next").click(function () {
			go_to_index(current_index + 1);
			return false;
		});

		jQuery(window).on('swipeleft', function () {
			go_to_index(current_index + 1);
		});
	});

	const go_to_index = function (index) {
		let carouselWidth = carousel.width();
		if (index < 0) index = total_slides - cardNumber;
		if (current_index === index) return;
		let left_offset = -1 * index * (100 / cardNumber);

		if (cardNumber + index - 1 === total_slides) {
			// go back to start
			index = 0;

			left_offset = 0;
		}

		slider.animate({ "left": `${left_offset}%` }, 250);
		$$invalidate(4, current_index = index);
	};

	function onwindowresize() {
		$$invalidate(1, screenWidth = window_1.innerWidth)
	}

	const click_handler = c => {
		if (screenWidth < 600) return; else handleClick(c.type);
	};

	const mouseenter_handler = c => handleHover('enter', c.type);
	const mouseleave_handler = () => handleHover('leave', '');
	const click_handler_4 = i => go_to_index(i);

	const click_handler_5 = () => {
		let card = content[current_index] && content[current_index].type;
		handleClick(card, true);
	};

	$$self.$$set = $$props => {
		if ('content' in $$props) $$invalidate(0, content = $$props.content);
		if ('selectCard' in $$props) $$invalidate(9, selectCard = $$props.selectCard);
		if ('hoverSelectCard' in $$props) $$invalidate(10, hoverSelectCard = $$props.hoverSelectCard);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*screenWidth*/ 2) {
			$: if (screenWidth > 1200) {
				$$invalidate(2, cardNumber = 4);
			}
		}

		if ($$self.$$.dirty & /*screenWidth*/ 2) {
			$: if (screenWidth < 1200) {
				$$invalidate(2, cardNumber = 3);
			}
		}

		if ($$self.$$.dirty & /*screenWidth*/ 2) {
			$: if (screenWidth < 900) {
				$$invalidate(2, cardNumber = 2);
			}
		}

		if ($$self.$$.dirty & /*screenWidth*/ 2) {
			$: if (screenWidth < 600) {
				$$invalidate(2, cardNumber = 1);
			}
		}

		if ($$self.$$.dirty & /*content, cardNumber*/ 5) {
			$: $$invalidate(5, sliderWidth = content.length / cardNumber * 100);
		}

		if ($$self.$$.dirty & /*cardNumber*/ 4) {
			$: slideWidth = 100 / cardNumber;
		}
	};

	return [
		content,
		screenWidth,
		cardNumber,
		activeCard,
		current_index,
		sliderWidth,
		handleClick,
		handleHover,
		go_to_index,
		selectCard,
		hoverSelectCard,
		onwindowresize,
		click_handler,
		mouseenter_handler,
		mouseleave_handler,
		click_handler_4,
		click_handler_5
	];
}

class Carousel extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			content: 0,
			selectCard: 9,
			hoverSelectCard: 10
		});
	}
}

export default Carousel;